import React from 'react';
import SharjeelBaigProfileImg from '../Images/sharjeel baig.PNG';
const initialState = {
    image:SharjeelBaigProfileImg,
    aboutImageText:'A simple ordinary Image of Sharjeel Baig, which is good to use as a profile Image',
}

function imageReducer(state = initialState,action) {
    switch (action.type) {
        case 'SharjeelBaigProfile':
            return{
image:state.image = SharjeelBaigProfileImg,
aboutImageText:state.aboutImageText = 'A simple ordinary Image of Sharjeel Baig, which is good to use as a profile Image',
            }
        default:
        return state
    }
}
 
export default imageReducer;